import { UploadImagemComponent } from './upload-imagem/upload-imagem.component';
import { FiltersModule } from './filters/filters.module';
import { CardsModule } from './cards/cards.module';
import { LoaderModule } from './loader/loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { NgbCarouselModule, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LayoutsModule } from './layouts/layouts.module';
import { FileUploadModule } from 'ng2-file-upload';
import { Ng2FileDropComponent } from './ng2-file-drop/ng2-file-drop.component';
import { ModalBackdropComponent } from './dialog/modal-backdrop/modal-backdrop.component';
import { VehicleNotFoundComponent } from './vehicle-not-found/vehicle-not-found.component';
import { EvaluationListReportComponent } from './evaluation/evaluation-vehicle-detail/evaluation-list-report/evaluation-list-report.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartLegendComponent } from './chart-legend/chart-legend.component';
import { AudioPlayerModule } from './audio-player/audio-player.module';
import { NgxGalleryModule } from '@app-components/ngx-gallery-video/ngx-gallery.module';
import { BannerManagementModule } from './banner-management/banner-management.module';
import { VehicleBannersComponent } from './vehicle-banners/vehicle-banners.component';
import { ShelfComponent } from './shelf/shelf.component';
import { OemDealersSliderComponent } from './vehicles-pages/cast-off-vehicles/oem-dealers-slider/oem-dealers-slider.component';
import { ReportItemComponent } from './report-item/report-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DialogUploadReportItemComponent } from './dialog/dialog-upload-report-item/dialog-upload-report-item.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { DialogUploadAudioReportItemComponent } from './dialog/dialog-upload-audio-report-item/dialog-upload-audio-report-item.component';
import { DialogNotificationComponent } from './dialog-notification/dialog-notification.component';
import { AdminCreateLocationModalComponent } from '@app/views/private/admin/advertisers/admin-advertisers/admin-edit-oemdealer/admin-edit-oem-dealer-locations/admin-create-location-modal/admin-create-location-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ShelfCarouselItemComponent } from './shelf/shelf-carousel-item/shelf-carousel-item.component';
import { ShelfGridItemComponent } from './shelf/shelf-grid-item/shelf-grid-item.component';
import { ShelfBannerItemComponent } from './shelf/shelf-banner-item/shelf-banner-item.component';
import { DialogAcceptTermsComponent } from './dialog/dealers-migration/dialog-accept-terms/dialog-accept-terms.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DialogEncouragingMigrationComponent } from './dialog/dealers-migration/dialog-encouraging-migration/dialog-encouraging-migration.component';
import { SbxWalletIframeComponent } from './sbxwallet-iframe/sbxwallet-iframe.component';
import { DialogAlreadySbxAccountComponent } from './dialog/dealers-migration/dialog-already-sbx-account/dialog-already-sbx-account.component';
import { DialogPendingSuperbidComponent } from './dialog/dealers-migration/dialog-pending-superbid/dialog-pending-superbid.component';
import { DialogPotentialDealersComponent } from './dialog/dialog-potential-dealers/dialog-potential-dealers.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { AutoRefreshSelectorComponent } from './auto-refresh-selector/auto-refresh-selector.component';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { DialogConfirmContractComponent } from './dialog/dialog-confirm-contract/dialog-confirm-contract.component';
import { FeatureAnnouncementComponent } from './feature-announcement/feature-announcement.component';
import { InputComponent } from '@app-shared/components/ui/input/input.component';
import { ComboboxComponent } from '@app-shared/components/ui/combobox/combobox.component';
import { TextareaComponent } from '@app-shared/components/ui/textarea/textarea.component';
import { DialogUnblockDealerBlacklistComponent } from './dialog/dialog-unblock-dealer-blacklist/dialog-unblock-dealer-blacklist.component';


const components = [
  BtnLoadingComponent,

  Ng2FileDropComponent,
  ModalBackdropComponent,
  VehicleNotFoundComponent,
  UploadImagemComponent,
  EvaluationListReportComponent,
  ChartLegendComponent,
  VehicleBannersComponent,
  ShelfComponent,
  OemDealersSliderComponent,
  DialogUploadReportItemComponent,
  DialogUploadAudioReportItemComponent,
  DialogNotificationComponent,
  DialogAcceptTermsComponent,
  AdminCreateLocationModalComponent,
  ShelfCarouselItemComponent,
  ShelfGridItemComponent,
  ShelfBannerItemComponent,
  DialogEncouragingMigrationComponent,
  DialogAlreadySbxAccountComponent,
  SbxWalletIframeComponent,
  DialogPendingSuperbidComponent,
  DialogConfirmContractComponent,
  DialogPotentialDealersComponent,
  DialogUnblockDealerBlacklistComponent,
];



@NgModule({
  imports: [
    CommonModule,
    LoaderModule,
    RouterModule,
    LayoutsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    PerfectScrollbarModule,
    NgbModule,
    FileUploadModule,
    MatTooltipModule,
    AudioPlayerModule,
    NgxGalleryModule,
    BannerManagementModule,
    CardsModule,
    FormsModule,
    MatInputModule,
    CurrencyMaskModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    NgbDropdownModule,
    NgbCarouselModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDialogModule,
    ReportItemComponent,
    AutoRefreshSelectorComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    FeatureAnnouncementComponent,
    InputComponent,
    ComboboxComponent,
    TextareaComponent,
  ],

  declarations: components,
  exports: [
    ...components,
    LoaderModule,
    ReportItemComponent,
    CardsModule,
    FiltersModule,
    AudioPlayerModule,
    BannerManagementModule,
    AutoRefreshSelectorComponent,
    FeatureAnnouncementComponent,
  ]
})
export class SharedComponentsModule { }
